export default function isCoverStoryTemplate(seedNode?: any): boolean {
  if (!seedNode) return false;

  return Boolean(
    seedNode && (
      seedNode.__typename === 'CoverStory' ||
      seedNode.contentType?.node?.name === 'cover-story' ||
      seedNode.contentTypeName === 'cover_story'
    )
  );
}
